/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Config lookup type (GET /internal/config?config=<type>) that provides the dropdown values for the field.
 * @export
 */
export const PortfolioFieldLookupType = {
    Additionalclassification: 'additionalclassification',
    Externalaccounttype: 'externalaccounttype',
    Portfoliolinktype: 'portfoliolinktype',
    Portfolioservicingroletype: 'portfolioservicingroletype'
} as const;
export type PortfolioFieldLookupType = typeof PortfolioFieldLookupType[keyof typeof PortfolioFieldLookupType];


export function instanceOfPortfolioFieldLookupType(value: any): boolean {
    for (const key in PortfolioFieldLookupType) {
        if (Object.prototype.hasOwnProperty.call(PortfolioFieldLookupType, key)) {
            if (PortfolioFieldLookupType[key as keyof typeof PortfolioFieldLookupType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioFieldLookupTypeFromJSON(json: any): PortfolioFieldLookupType {
    return PortfolioFieldLookupTypeFromJSONTyped(json, false);
}

export function PortfolioFieldLookupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioFieldLookupType {
    return json as PortfolioFieldLookupType;
}

export function PortfolioFieldLookupTypeToJSON(value?: PortfolioFieldLookupType | null): any {
    return value as any;
}

export function PortfolioFieldLookupTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioFieldLookupType {
    return value as PortfolioFieldLookupType;
}

